/**
 * @ngdoc directive
 * @name iframeOnload
 *
 */

(function() {
  'use strict';

  app.directive('iframeOnload', directive);

  function directive() {
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      link: function($scope, $element) {
        $element.on('load', function(){
          return $scope.callBack();
        });
      }
    };
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/iframeOnloadDirective.js